import React from 'react';
import './App.css';
import NavBar from "./components/nav-bar/NavBar";
import {Outlet} from "react-router-dom";
import Footer from "./components/footer/Footer";

function App() {
    return (
        <>
            <div className="content">
                <NavBar/>
                <Outlet />
            </div>
            <Footer />
        </>
    );
}

export default App;